<template>
  <div class="wrap">
    <div class="titleWrap">
      <strong>{{portfolio.title}}</strong>
    </div>

    <div class="content">
      <img :src="`//${portfolio.savedUrl}${portfolio.savedFileName}`">
    </div>
  </div>
</template>

<script>
    export default {
        name: "portfolio-item-modal",
        components: {},
        props: ['portfolio'],
        computed: {},
        watch: {},
        methods: {},
        data() {
            return {}
        },
        created() {

        },
        updated() {

        },
        mounted() {
          document.getElementsByClassName('v--modal-box')[0].style.overflowY = 'scroll';
        },


    }
</script>

<style scoped lang="scss">
  .wrap{
    background-color: #505050;
    .titleWrap{
      text-align: center;
      font-size:1.5rem;
      color:#fff;
      padding:1rem 0;
    }
    .content{
      width:95%;
      height:100%;
      margin:0 auto;
      box-shadow: 0px 5px 3px 2px #000000;
      box-sizing: content-box;
      >img {
        width:100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/PortfolioItemModal.vue